import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user.role) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      navigate("/admin");
    } else {
      setError(res.error || "No se pudo iniciar sesión.");
    }
  };

  return (
    <div
      className="min-h-[calc(100vh-200px)] flex items-center justify-center px-6 py-20"
      data-testid="login-page"
    >
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md"
        data-testid="login-form"
      >
        <div
          className="text-xs uppercase tracking-[0.35em] mb-4"
          style={{ color: "var(--rincon-secondary)" }}
        >
          Acceso privado
        </div>
        <h1
          className="font-display text-5xl tracking-tight mb-2"
          style={{ color: "var(--rincon-text)" }}
        >
          Entrar al taller
        </h1>
        <p
          className="font-body italic mb-10"
          style={{ color: "var(--rincon-text-muted)" }}
        >
          Sólo el autor tiene llave.
        </p>

        <label className="block mb-6">
          <span
            className="text-xs uppercase tracking-[0.2em]"
            style={{ color: "var(--rincon-text-muted)" }}
          >
            Correo
          </span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="mt-2 w-full bg-transparent border-b py-2 font-body text-lg outline-none focus:border-[var(--rincon-primary)] transition-colors"
            style={{
              borderColor: "var(--rincon-border)",
              color: "var(--rincon-text)",
            }}
          />
        </label>

        <label className="block mb-10">
          <span
            className="text-xs uppercase tracking-[0.2em]"
            style={{ color: "var(--rincon-text-muted)" }}
          >
            Contraseña
          </span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="mt-2 w-full bg-transparent border-b py-2 font-body text-lg outline-none focus:border-[var(--rincon-primary)] transition-colors"
            style={{
              borderColor: "var(--rincon-border)",
              color: "var(--rincon-text)",
            }}
          />
        </label>

        {error ? (
          <div
            className="mb-6 font-body text-sm italic"
            style={{ color: "var(--rincon-error)" }}
            data-testid="login-error"
          >
            {error}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={submitting}
          data-testid="login-submit-button"
          className="w-full py-4 font-display text-lg tracking-wide transition-colors disabled:opacity-60"
          style={{
            background: "var(--rincon-primary)",
            color: "var(--rincon-bg)",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "var(--rincon-primary-hover)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "var(--rincon-primary)")}
        >
          {submitting ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
